const token = localStorage.getItem('token');

export const get_users = async () => {
  try {
    const url = `${process.env.REACT_APP_API_GCOM_URL}/users`;
    const params = {
      method: 'GET',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const post_user = async (data) => {
  try {
    const url = `${process.env.REACT_APP_API_GCOM_URL}/users`;
    const params = {
      method: 'POST',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const update_user = async (data) => {
  try {
    const id = data._id || data.id;
    const url = `${process.env.REACT_APP_API_GCOM_URL}/users/${id}`;
    const params = {
      method: 'PATCH',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const delete_user = async (data) => {
  try {
    const id = data._id || data.id;
    const url = `${process.env.REACT_APP_API_GCOM_URL}/users/${id}`;
    const params = {
      method: 'DELETE',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}
